import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { ICCService } from '../../icc.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { FleetConfiguration } from '../../model/fleet-configuration';
import { StaticRoute } from '../../model/static-route';
import { Util } from '../../utils';

let $ = require('jquery');
let _ = require('lodash');

@Component({
  selector: 'configure-static-route',
  styles: [require('../../icc.scss')],
  template: require('./static-route-configuration.html'),
  providers: [
    ICCService, TranslateService
  ]
})

export class StaticRouteConfiguration {
    @Input() fleetConfig: FleetConfiguration;
    @Input() errorFlag: boolean;
    @Input() errorMessage: string;
    @Output() staticRoutesValidated:  EventEmitter<any> = new EventEmitter();
    private isTranslationready: boolean = true;
    private isNetworkValid: Array<Boolean> = [true]
    private isNextHopeValid: Array<Boolean> = [true]
    private isExpanded: Array<boolean> = [true];
    constructor(public appState: AppState,
        public service: ICCService,
        private translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnChanges(changes) {
        const fleetConfigChange = changes['fleetConfig'];
        if(fleetConfigChange){
          if(this.fleetConfig){
            this.staticRoutesValidated.emit({
                isValid: true
              })
          }
        }
      }

    private addEmptyStaticRoute(){
        this.fleetConfig.staticRoutes.push(Util.getEmptyStaticRoute());
        this.isExpanded[this.fleetConfig.staticRoutes.length - 1] = true;
        this.isNetworkValid[this.fleetConfig.staticRoutes.length - 1] = false;
        this.isNextHopeValid[this.fleetConfig.staticRoutes.length - 1] = false;
        this.validateStaticRoutes();
    }

    private removeStaticRoute(staticRoute,event,i){
        this.fleetConfig.staticRoutes.splice(i, 1);
        this.isNetworkValid.splice(i,1);
        this.isNextHopeValid.splice(i,1);
        this.validateStaticRoutes();
    }

    private validateStaticRoutes(){
        let validate: boolean = true;
        for( let index:number=0; index< this.isNetworkValid.length ; ++index ){
           if(!this.isNetworkValid[index]){
                validate = false;
                break;
           }
           if(!this.isNextHopeValid[index]){
                validate = false;
                break;
       }
        }
        this.staticRoutesValidated.emit({
          isValid: validate
        })
    }

    private validateNetwork(event,i){
        this.isNetworkValid[i] =  !event.target.validity.patternMismatch
        this.validateStaticRoutes();
    }

    private validateNextHop(event,i){
        this.isNextHopeValid[i] =  !event.target.validity.patternMismatch
        this.validateStaticRoutes();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/wizard/steps/static-route-configuration.component.ts